import { gql } from '@apollo/client';

export const createIndividualFromSessionQuery = gql`
  mutation createIndividualFromSession($disLangcode: String!) {
    createIndividualFromSession(langcode: $disLangcode)
  }
`;
